import { useEffect, useState } from "react";
import { ForkKnife, Coffee, IceCream } from "@phosphor-icons/react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import AwardPopup from "../components/AwardPopup";
import SectionPrompt from "../components/SectionPrompt";
import SocialProof from "../components/SocialProof";
import HowItWorks from "../components/HowItWorks";
import PopularTonight from "../components/PopularTonight";
import ExclusiveToMyLocal from "../components/ExclusiveToMyLocal";
import WhyMyLocal from "../components/WhyMyLocal";
import JoinCTA from "../components/JoinCTA";
import Experience from "../components/Experience";
import DownloadCTA from "../components/DownloadCTA";
import Footer from "../components/Footer";
import { getBusinesses, getStats } from "../lib/api";

export default function Landing() {
  const [popular, setPopular] = useState([]);
  const [exclusive, setExclusive] = useState([]);
  const [stats, setStats] = useState({
    orders_completed: 500000,
    years_serving: 6,
    local_businesses: 40,
    location: "Strabane & Lifford",
  });

  useEffect(() => {
    (async () => {
      try {
        const [p, ex, s] = await Promise.all([
          getBusinesses({ popular: true }),
          getBusinesses({ exclusive: true }),
          getStats(),
        ]);
        setPopular(p);
        setExclusive(ex);
        setStats(s);
      } catch (e) {
        console.warn("Failed to load initial data", e);
      }
    })();
  }, []);

  return (
    <div data-testid="landing-page" className="relative">
      <AwardPopup />
      <Navbar />
      <main>
        <Hero />
        <SectionPrompt
          testId="prompt-quick-bite"
          text="Quick bite?"
          icon={<ForkKnife size={14} weight="duotone" className="text-[#FF1F8B]" />}
        />
        <PopularTonight businesses={popular} />
        <SectionPrompt
          testId="prompt-something-filling"
          text="Something filling?"
          icon={<Coffee size={14} weight="duotone" className="text-[#FF1F8B]" />}
        />
        <ExclusiveToMyLocal businesses={exclusive} />
        <SocialProof stats={stats} />
        <SectionPrompt
          testId="prompt-treat-yourself"
          text="Treat yourself tonight"
          icon={<IceCream size={14} weight="duotone" className="text-[#FF1F8B]" />}
        />
        <HowItWorks />
        <WhyMyLocal />
        <JoinCTA />
        <Experience />
        <DownloadCTA />
      </main>
      <Footer />
    </div>
  );
}
